'use client';

import React from 'react';
import Image from 'next/image';

import { Button } from '~/components/ui/button';
import { Input } from '~/components/ui/input';
import { EMAIL_COLLECTION_ENDPOINT } from '~/lib/constants';

import brightenInboxIcon from './_assets/brighten-inbox-icon.png';

export function BlogCloserEmailCollection() {
  const [slug, setSlug] = React.useState<string>('');
  const [honeypot, setHoneypot] = React.useState(false);

  React.useEffect(() => {
    setSlug(window.location.pathname);
  }, []);

  return (
    <section className='container xl:max-w-7xl'>
      <div className='bg-secondary rounded-2xl px-5 pb-8 lg:px-16 lg:pb-16'>
        <header className='mx-auto mb-8 flex max-w-2xl flex-col text-center text-white md:items-center'>
          <Image
            src={brightenInboxIcon}
            alt='Brighten Your Inbox Icon'
            className='mx-auto max-sm:w-3/4'
            width={344}
            height={159}
          />
          <h2 className='heading-base mt-5'>Brighten Your Inbox</h2>
          <p className='body-lg mt-3 text-white/80'>
            Care and comfort for parents, delivered through stories of families whose dark days have turned bright with
            the help of our Starlight community.
          </p>
        </header>
        <form action={EMAIL_COLLECTION_ENDPOINT} className='mx-auto max-w-4xl' method='post'>
          <div className='dark mb-5 grid gap-5 lg:grid-cols-3'>
            {/* Honeypot */}
            <div hidden>
              <label htmlFor='g0tcha'> g0tcha</label>
              <input
                aria-label='g0tcha'
                name='g0tcha'
                onChange={(event) => setHoneypot(!!event.target.value)}
                type='text'
              />
            </div>
            {/* Pardot hidden form fields START */}
            <div hidden>
              <label htmlFor='form_id'>Form ID</label>
              <Input defaultValue={`email-collection-general`} name='form_id' readOnly type='text' />
            </div>
            <div hidden>
              <label htmlFor='slug'>Slug</label>
              <Input defaultValue={slug} name='slug' readOnly type='text' />
            </div>
            {/* Pardot hidden form fields END */}
            <div>
              <label className='sr-only' htmlFor='first_name'>
                First Name
              </label>
              <Input name='first_name' placeholder='First name' required type='text' />
            </div>
            <div>
              <label className='sr-only' htmlFor='last_name'>
                Last Name
              </label>
              <Input name='last_name' placeholder='Last name' required type='text' />
            </div>
            <div>
              <label className='sr-only'>Your Email</label>
              <Input name='email' placeholder='Your email' required type='text' />
            </div>
          </div>
          <div>
            <Button className='w-full rounded-lg' disabled={honeypot} type='submit' variant='inverted'>
              Brighten My Inbox
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
}
